module.exports = __webpack_public_path__ + "img/PopupbannerROG_JFXGOLDX.cbaf6e6a.png";